import { showError } from "./toastUtils";

const humanizeMessage = (msg = "") => {
  return msg
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

export const handleApiValidationError = (err, setErrors) => {
  let backendErrors = err?.response?.data;

  if (backendErrors.label === "DEVELOPMENT ERROR") {
    backendErrors = backendErrors?.error;
  }

  let fieldErrors = {};

  if (Array.isArray(backendErrors.details)) {
    backendErrors.details.forEach((e) => {
      fieldErrors[e.field] = humanizeMessage(e.message);
    });

    setErrors(fieldErrors);
    showError("Please fix the highlighted errors");
    return true;
  }

  if(backendErrors?.details?.providerResponse) {
    showError(backendErrors?.details?.providerResponse?.meta?.message);
    return true;
  } 

  showError(err?.response?.data?.message || "Something went wrong");
  fieldErrors["general"] = err?.response?.data?.message;

  setErrors(fieldErrors);
  return false;
};

// for product array listing
export const handleApiValidationErrorforArray = (err, setErrors) => {
  let backendErrors = err?.response?.data;

  // ✅ SAFETY CHECK (IMPORTANT)
  if (!backendErrors) {
    showError(err.message || "Something went wrong");
    return false;
  }

  if (backendErrors?.label === "DEVELOPMENT ERROR") {
    backendErrors = backendErrors?.error;
  }

  if (Array.isArray(backendErrors?.details)) {
    const fieldErrors = {};

    backendErrors.details.forEach((e) => {
      const parts = e.field?.split("."); // safe

      if (parts?.[0] === "variants") {
        const index = parts[1];
        let field = parts[2];

        if (field === "costprice") field = "costPrice";

        if (!fieldErrors[index]) fieldErrors[index] = {};

        fieldErrors[index][field] = humanizeMessage(e.message);
      }
    });

    setErrors(fieldErrors);

    showError("Please fix the highlighted errors");
    return true;
  }

  // ✅ fallback
  showError(backendErrors?.message || "Something went wrong");
  return false;
};
